import type { SeoRunStatus } from '../../../../shared/seo-run';
import { runOutcome } from '../../lib/run-outcome';

/** This component consumes only the verified public status projection. */
export function SeoResearchReport({status}: {status: SeoRunStatus}) {
 const outcome=runOutcome({task_slug:'agent_run_circle_seo',status:'failed',seo_research:status});
 return <section className="rounded-2xl border border-slate-200 bg-white p-5 space-y-3" aria-label="SEO research report">
  <h2 className="text-lg font-semibold">SEO research report</h2>
  <p>{outcome.description}</p>
  <p>Cost: {status.costUsd === null ? 'unknown':`$${status.costUsd.toFixed(4)}`}</p>
  {(status.status === 'completed' || status.status === 'review_required') && status.result && <>
   <p className="text-xs break-all">Saved result: {status.artifactId}</p>
   <div className="overflow-x-auto"><table className="w-full text-sm text-left"><thead><tr><th>Keyword / fit</th><th>Search demand</th><th>Analytics coverage</th></tr></thead><tbody>
    {status.result.candidates.map(c=><tr key={c.term} className="border-t align-top">
     <td className="py-2 pr-3">{c.term}<p>{c.classification}</p><p>{c.reason}</p></td>
     <td className="py-2 pr-3">{c.demand.status}{c.demand.volumeBySource.map(v=><p key={v.source}>{v.source}: {v.volume ?? 'unknown'}</p>)}</td>
     <td className="py-2">{c.coverage.status}<p>Impressions: {c.coverage.impressions ?? 'unknown'} · Clicks: {c.coverage.clicks ?? 'unknown'}</p><p>Position: {c.coverage.averagePosition ?? 'unknown'}</p><p>{c.coverage.requestedStart} – {c.coverage.requestedEnd}</p></td>
    </tr>)}
   </tbody></table></div>
  </>}
 </section>;
}
